import { RootState } from 'store/root-reducer';

export const getPlatformsList = (state: RootState) => state.statistics.platformsList;
